import React from "react";
import { Grid } from "@material-ui/core";
import { LogoRipleyBlancoIcon } from "../../../common/components/Icon";
import { HeaderJss } from './styleJss';

const Header = () => {
  const classes = HeaderJss();
  return (
    <Grid container item justifyContent="center" className={classes.appBar}>
      <Grid container item sm={12} md={10} className={classes.logoRipleyContainer} >
        <LogoRipleyBlancoIcon />
      </Grid>
    </Grid>
  )
}

export default Header
